<template>
  <div class="encryption">
    <ul class="encryption-list clearfix">
      <template v-if="list.length > 0">
        <li class="list-nav" v-for="(item, i) in list" :key="i"  @click="jump(item, i)" :class="[active.title == item.title ? 'active' : '']">
          <span>{{ item.title }}</span>
        </li>
      </template>
      
    </ul>
    <div class="encryption-main">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { routes } from '@/router/index'
export default {
  data () {
    return {
      active: {},
      list: [],
      path: ''
    }
  },
  watch: {
    '$route' (val) {
      if (val.matched[0].path == this.path) {
        this.active = this.list.filter((e) => {
          return e.path == val.path
        })[0]
      } else {
        this.setList()
      }
    }
  },
  created () {
    this.setList()
  },
  methods: {
    async setList () {
      this.path = this.$route.matched[0].path
      let routeOb = await routes.filter(e => {
        return e.path == this.$route.matched[0].path
      })[0]
      if (routeOb.children) {
        this.list = await routeOb.children.map(e => {
          return {
            title: e.meta.title,
            path: this.$route.matched[0].path + '/' + e.path
          }
        })
      }
      
      this.active = await this.list.filter((e) => {
        return e.path == this.$route.path
      })[0]
    },
    jump (item) {
      this.$router.push({ path: item.path })
    }
  }
}
</script>

<style lang="stylus" scope>
.encryption
  .encryption-list
    background-color #fff
    .list-nav
      float left
      line-height 40px
      margin 0 20px
      cursor pointer
      color #333
      font-size 14px
      border-bottom 0px solid #1890ff
      transition color .3s
    .active
      color #1890ff
      border-bottom-width 2px
  .encryption-main
    // background-color #fff
    margin-top 20px    
    
</style>